<template>
	<core-layout-content full>
		<!-- Headline -->
		<core-layout-headline-and-actions>
			<template slot="headline">{{ $t("object") }}</template>
		</core-layout-headline-and-actions>

		<!-- Loading -->
		<j-loading-toast v-if="isLoading" />

		<div class="mt4">
			<core-entity-card
				:entity="computedObject"
				:hasActions="true"
				:pinnable="false"
				:isExpanded="true"
				@updated="fetchObject"
				@added="fetchObject"
				@deleted="fetchObject"
			/>
			<!-- Footer -->
			<div class="flex xs-12 xs-right mt6" slot="footer">
				<j-button
					type="error"
					@click="$modal.show('j-dialog')"
					:isLoading="isDeleteLoading"
				>
					<crm-icon name="delete" color="c5" class="mr2" />Delete
				</j-button>
			</div>
		</div>

		<!-- Delete confirmation modal -->
		<j-dialog
			:height="200"
			:width="600"
			:title="$t('delete')"
			type="delete"
			@confirm="deleteObject"
			>{{ $t("errors.are_you_sure_you_want_to_delete_object") }}</j-dialog
		>
	</core-layout-content>
</template>

<script>
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import CoreLayoutHeadlineAndActions from "@/modules/core/components/CoreLayoutHeadlineAndActions"
import CoreEntityCard from "@/modules/core/components/CoreEntityCard"
import JButton from "@/components/JButton"
import CrmIcon from "@/components/CrmIcon"
import JDialog from "@/components/JDialog/"
import JLoadingToast from "@/components/JLoadingToast/"

import api from "@/api/gql.js"
import { gql } from "@/api/utils.js"

export default {
	components: {
		CoreLayoutContent,
		CoreLayoutHeadlineAndActions,
		CoreEntityCard,
		JButton,
		CrmIcon,
		JDialog,
		JLoadingToast
	},

	data() {
		return {
			isLoading: false,
			isDeleteLoading: false,
			fetchedObject: null
		}
	},

	methods: {
		async fetchObject() {
			const query = gql`
				query objects($where: objectWhereInput) {
					objects(where: $where) {
						totalCount
						list {
							__typename
							id
							name
							facts {
								id
								type
								value {
									booleanValue
									dateValue
									numberValue
									stringValue
									arrayValue {
										stringValue
									}
								}
							}
							addresses {
								id
								type
								fields2 {
									type
									value
								}
								fields
							}
							relationships {
								id
								createdAt
								entity {
									name
								}
								type
								values {
									key
									value
								}
							}
							createdAt
						}
					}
				}
			`

			const variables = {
				where: {
					id: this.$route.params.id
				}
			}

			this.isLoading = true

			const res = await api({ query, variables })

			this.isLoading = false

			this.fetchedObject = res?.data?.objects?.list?.[0]
		},

		async deleteObject() {
			const query = gql`
				mutation deleteObject($id: String!) {
					deleteEntity(id: $id) {
						status
						errors
						errors_2 {
							code
							message
						}
					}
				}
			`

			this.isDeleteLoading = true
			const res = await api({ query, variables: { id: this.$route.params.id } })
			this.isDeleteLoading = false

			if (res?.data?.deleteEntity?.status !== "success") {
				this.$store.dispatch("addMessage", {
					message: {
						type: "error",
						text:
							res?.errors ||
							res?.data?.deleteEntity?.errors ||
							res?.data?.deleteEntity?.errors_2?.message ||
							this.$t("errors.general")
					}
				})
			} else
				this.$store.dispatch("addMessage", {
					message: {
						type: "success",
						text: this.$t("object_deleted")
					}
				})

			this.$router.push({ name: "ObjectsList" })
		}
	},

	computed: {
		computedObject() {
			return this.fetchedObject
		}
	},

	created() {
		this.fetchObject()
	}
}
</script>
